function getOpenApiToken() {
  let accessToken: string | null = null;
  // Cookie is not a DOM element, so we need to disable the eslint rule
  // eslint-disable-next-line no-restricted-globals
  const value = `; ${document.cookie}`;
  const parts = value.split('; BBV2APITOKEN=');
  if (parts.length === 2) {
    const part = parts.pop() || '';
    accessToken = part.split(';').shift() || null;
  }

  if (!accessToken) {
    console.warn('No V2 API Token found in cookies');
    return '';
  }

  return accessToken;
}

export { getOpenApiToken };
